import { useState } from 'react';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import AdminLogin from '@/pages/admin/components/AdminLogin';
import AdminSidebar, { AdminTab } from '@/pages/admin/components/AdminSidebar';
import MenuTab from '@/pages/admin/components/MenuTab';
import ExtrasTab from '@/pages/admin/components/ExtrasTab';
import SliderTab from '@/pages/admin/components/SliderTab';
import HomepageTab from '@/pages/admin/components/HomepageTab';
import BrandingTab from '@/pages/admin/components/BrandingTab';
import SettingsTab from '@/pages/admin/components/SettingsTab';

const AdminPage = () => {
  const { isAuthenticated, isVerifying, error, login, logout, clearError } = useAdminAuth();
  const [activeTab, setActiveTab] = useState<AdminTab>('menu');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  if (!isAuthenticated) {
    return (
      <AdminLogin
        onLogin={login}
        isVerifying={isVerifying}
        error={error}
        onClearError={clearError}
      />
    );
  }

  const renderTab = () => {
    switch (activeTab) {
      case 'menu': return <MenuTab />;
      case 'extras': return <ExtrasTab />;
      case 'slider': return <SliderTab />;
      case 'homepage': return <HomepageTab />;
      case 'branding': return <BrandingTab />;
      case 'settings': return <SettingsTab />;
      default: return <MenuTab />;
    }
  };

  return (
    <div className="flex min-h-screen bg-gray-50" style={{ fontFamily: "'Inter', sans-serif" }}>
      <div className="hidden lg:block flex-shrink-0">
        <AdminSidebar activeTab={activeTab} onTabChange={setActiveTab} onLogout={logout} />
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-50 flex">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileMenuOpen(false)}
          />
          <div className="relative z-10 flex-shrink-0">
            <AdminSidebar
              activeTab={activeTab}
              onTabChange={(tab) => { setActiveTab(tab); setMobileMenuOpen(false); }}
              onLogout={logout}
            />
          </div>
        </div>
      )}

      <div className="flex-1 flex flex-col min-w-0">
        <div className="lg:hidden flex items-center justify-between px-4 py-3 bg-white border-b border-gray-100">
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-100 text-gray-600 cursor-pointer"
          >
            <i className="ri-menu-line text-lg"></i>
          </button>
          <span className="text-sm font-semibold text-gray-900">Yönetici Paneli</span>
          <button
            onClick={logout}
            className="w-9 h-9 flex items-center justify-center rounded-xl bg-gray-100 text-gray-600 cursor-pointer"
          >
            <i className="ri-logout-box-line text-lg"></i>
          </button>
        </div>

        <main className="flex-1 flex flex-col min-w-0 min-h-0 overflow-hidden">
          <div className="flex-1 w-full min-h-0 overflow-y-auto overflow-x-hidden p-6 lg:p-8">
            {renderTab()}
          </div>
        </main>
      </div>
    </div>
  );
};

export default AdminPage;
